import { render, staticRenderFns } from "./ItemLevel.vue?vue&type=template&id=026828e5&"
import script from "./ItemLevel.vue?vue&type=script&lang=ts&"
export * from "./ItemLevel.vue?vue&type=script&lang=ts&"
import style0 from "./ItemLevel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports